import React, { useState, useCallback } from "react";
import { SManagement } from "../../ReusableComponents/CommonApis";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useDropzone } from "react-dropzone";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import axiosInstance from "../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { MdFileDownload } from "react-icons/md";
import { RiDownload2Fill } from "react-icons/ri";
import { exportToExcel } from "../../Student/Reusablecomponents/RegularFunctions";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { RiFileExcel2Fill } from "react-icons/ri";
const SchoolBulk = (props) => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);

    const [SFName, SetSFName] = useState("");
    const [ValidRecords, SetValidRecords] = useState();
    const [InValidRecords, SetInValidRecords] = useState();
    const [SchoolMDetails, SetSchoolMDetails] = useState({
        SchoolManagement: "",
        Boardofexam: "",
    });
    const [Finialrecords, SetFinialrecords] = useState([]);
    const [SchoolErrors, SetSchoolErrors] = useState({});

    const StoreDetails = (e, Name) => {
        SetSchoolMDetails({ ...SchoolMDetails, [e.target?.name || Name]: e });
    };
    // 
    const ActuallHeader = ["S.No", "School UDISE", "School Name", "District", "School Loacation Rural / Urban",
        "City", "Contact name", "Contact number", "Email ID", "Address", "Pincode", "Medium of Instruction"];
    const validateHeader = (headerRow, expectedHeader) => {
        return JSON.stringify(headerRow) === JSON.stringify(expectedHeader);
    };
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            alert("Only .xls and .xlsx files are allowed");
            return;
        }
        const file = acceptedFiles[0];
        SetSFName(file?.name);
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
            const isHeaderValid = validateHeader(headers, ActuallHeader);
            if (!isHeaderValid) {
                alert("Invalid header in Excel file. Please check the file and try again.");
                SetSFName("")
                return "";
            }
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            const XLDATA = jsonData?.map((row) => ({
                UDISE: row?.["School UDISE"],
                SchoolName: row?.["School Name"],
                SchoolManagement: row?.["School Management"],
                District: row?.District,
                SLocation: row?.["School Loacation Rural / Urban"],
                City: row?.City,
                CName: row?.["Contact name"],
                PNumber: row?.["Contact number"],
                EMail: row?.["Email ID"],
                Address: row?.Address,
                Pincode: row?.Pincode,
                MOI: row?.["Medium of Instruction"],
            }))
            const validRecords = [];
            const invalidRecords = [];
            const schoolNameMap = new Map();
            const udiseMap = new Map();
            for (let i = 0; i < XLDATA.length; i++) {
                const currentRecord = XLDATA[i];
                try {
                    await validationSchema.validate(currentRecord, { abortEarly: false });
                    const errors = [];
                    // const schoolName = currentRecord?.SchoolName?.trim()?.toLowerCase();
                    const udise = currentRecord?.UDISE?.toString()?.trim();
                    // if (schoolName) {
                    //     if (schoolNameMap.has(schoolName)) {
                    //         errors.push({ field: "SchoolName", message: "Duplicate School Name" });
                    //     } else {
                    //         schoolNameMap.set(schoolName, i);
                    //     }
                    // }

                    if (udise) {
                        if (udiseMap.has(udise)) {
                            errors.push({ field: "UDISE", message: "Duplicate School UDISE Code" });
                        } else {
                            udiseMap.set(udise, i);
                        }
                    }
                    if (errors.length > 0) {
                        invalidRecords.push({ data: currentRecord, errors: errors });
                    } else {
                        validRecords.push(currentRecord);
                    }
                } catch (err) {
                    invalidRecords.push({
                        data: currentRecord,
                        errors: err.inner.map((error) => ({
                            field: error.path,
                            message: error.message
                        }))
                    });
                }
            }
            const FinialValidRecords = {
                instituteId: props?.SINID?.value,
                regionId: props?.SRegion?.value || 0,
                stateId: props?.SStatte?.value || 0,
                schoolManagementId: SchoolMDetails.SchoolManagement,
                boardId: SchoolMDetails?.Boardofexam,
                createdBy: items?.userId,
                societyId: props?.SSociety?.value || 0,
                schools: validRecords.map((SH) => ({
                    udiseCode: SH?.UDISE.toString(),
                    schoolName: SH?.SchoolName,
                    townCity: SH?.City,
                    contactName: SH?.CName,
                    contactPhone: SH?.PNumber.toString(),
                    eMail: SH?.EMail,
                    address: SH?.Address.toString(),
                    pinCode: SH?.Pincode?.toString() || "",
                    mediumId: SH?.MOI,
                    districtId: SH?.District,
                    // hierarchyvaluesListCSV:props?.SINID === "2" ? `${props?.SStatte},${props?.SRegion}` : `${props?.SRegion},${props?.SStatte}` ,
                    hierarchyvaluesListCSV: props?.SINID?.value === 2
                        ? [props?.SStatte?.value, props?.SRegion?.value].filter(Boolean).join(",")
                        : [props?.SRegion?.value, props?.SStatte?.value].filter(Boolean).join(","),
                    stationId: 0,
                    schooltypeId: SH?.SLocation,
                    loginId: "",
                    password: "",
                }))
            }
            SetValidRecords(FinialValidRecords);
            SetInValidRecords(invalidRecords);
        }
        reader.readAsArrayBuffer(file);
    })


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        //  disabled: !(SchoolMDetails.SchoolManagement && SchoolMDetails?.Boardofexam),
        accept: {
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
                ".xlsx",
            ],
        },
        multiple: false,
    });
    const validationSchema =
        Yup.object().shape({
            UDISE: Yup.string().trim()
                .required("School U-DISE Code is required")
                .test("len", "School U-DISE Code should be exactly 11 digits", (val) => !val || val.length === 11)
                .matches(/^\d{11}$/, {
                    message: "School U-DISE Code must contain exactly 11 digits",
                    excludeEmptyString: true,
                }),
            SchoolName: Yup.string().trim().required("School Name is required")
                .max(200, "School Name cannot exceed 200 characters")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "School Name must contain only alphabets",
                    excludeEmptyString: true,
                }),
            // SchoolManagement: Yup.string().required("School Management is required"),
            // System: Yup.string().required("System is required"),
            // Region: Yup.string().when("System", {
            //   is: (System) => System === "1" || System === "3",
            //   then: () => Yup.string().required("Region is required"),
            //   otherwise: () => Yup.string().notRequired(),
            // }),
            // State: Yup.string().required("State is required"),
            District: Yup.string().required("District is required")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "District must contain only alphabets",
                    excludeEmptyString: true,
                }),
            //  Society : Yup.string().required("Society is required"),
            // Society: Yup.string().when("System", {
            //   is: (System) => System === "5" || System === "8" || System === "9",
            //   then: () => Yup.string().required("Society is required"),
            //   otherwise: () => Yup.string().notRequired(),
            // }),
            // Station: Yup.string().when("System", {
            //   is: (System) => System === "6",
            //   then: () => Yup.string().required("Station is required"),
            //   otherwise: () => Yup.string().notRequired(),
            // }),
            // Boardofexam: Yup.string().required("Board is required"),
            SLocation: Yup.string().required("School Location is required"),
            City: Yup.string().required("City is required")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "City must contain only alphabets",
                    excludeEmptyString: true,
                }),
            CName: Yup.string().trim().required("Contact Name is required").max(50, "Contact Name cannot exceed 50 characters")
                .matches(/^[A-Za-z.\s]+$/, {
                    message: "Contact Name must contain only alphabets",
                    excludeEmptyString: true,
                }),
            PNumber: Yup.string().trim().required("Contact Number is required")
                .matches(/^\d{10}$/, {
                    message: "Contact Number must be exactly 10 digits",
                    excludeEmptyString: true,
                }),
            EMail: Yup.string().required("Email Id is required").email("Enter a valid Email Id"),
            Address: Yup.string().trim().required("Address is required").max(200, "Address cannot exceed 200 characters"),
            Pincode: Yup.string().required("PinCode is required")
                .matches(/^\d{6}$/, {
                    message: "PinCode must be exactly 6 digits",
                    excludeEmptyString: true,
                }),
            MOI: Yup.string().required("Medium is required"),
        });
    const PostRecords = async () => {
        if (!SchoolMDetails.SchoolManagement || !SchoolMDetails?.Boardofexam) {
            notify(`${SchoolMDetails.SchoolManagement ? "Board of Exam" : "School Management "} field is required`, "warning");
            return ""
        }
        try {
            const res = await axiosInstance.post(`/NCLAdmin/AddBulkSchools`, ValidRecords);
            if (res.data?.errorCode < 0) {
                const ResInvalid = (ValidRecords?.schools || [])
                    .filter(school =>
                        (res.data?.errors || []).some(error =>
                            error.udiseCode === school.udiseCode &&
                            error.schoolName === school.schoolName
                        )
                    )
                    .map(school => {
                        const schoolErrors = (res.data?.errors || [])
                            .filter(error =>
                                error.udiseCode === school.udiseCode &&
                                error.schoolName === school.schoolName
                            )
                            .flatMap(error =>
                                (error.field || "")
                                    .split(",")
                                    .filter(field => field.trim() !== "")
                                    .map(field => ({
                                        field: field.trim(),
                                        message:
                                            field.trim() === "UdiseCode" ? "UdiseCode is already Inserted" :
                                                field.trim() === "DistrictName" ? "Invalid District" : "School is already inserted"
                                    }))
                            );

                        return {
                            data: { ...school },
                            errors: schoolErrors
                        };
                    });

                SetFinialrecords({
                    TotalRecords: (ValidRecords?.schools?.length || 0) + (InValidRecords?.length || 0),
                    ValidRecords: res.data?.insertedCount,
                    //  ValidRecords: (ValidRecords?.schools?.length || 0) - ResInvalid.length,
                    InValidRecords: [...InValidRecords, ...ResInvalid],
                    INValidCount: (InValidRecords?.length || 0) + ResInvalid.length,
                    Names: res.data?.names
                });
            } else {
                SetFinialrecords({
                    TotalRecords: (ValidRecords?.schools?.length || 0) + (InValidRecords?.length || 0),
                    ValidRecords: res.data?.insertedCount,
                    InValidRecords: [...InValidRecords],
                    INValidCount: InValidRecords?.length || 0,
                })
            }
        }
        catch (err) {
            console.log(err)
        }
    }
    const DownloadSamplefile = () => {
        const a = document.createElement("a");
        a.href = `/SchoolsRegistration.xlsx`;
        a.download = "SchoolsRegistrationTemplate.xls";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const DownloadFIle = () => {
        const XL = (Finialrecords?.InValidRecords || InValidRecords)?.map((item, index) => {
            const Data = item?.data;
            return {
                Reasons: item?.errors
                    ?.filter((error, index, self) =>
                        index === self.findIndex(e => e.field === error.field)
                    )
                    ?.map(error => error.message)
                    .join(", "),
                "S.No": index + 1,
                "School UDISE": Data?.udiseCode || Data?.UDISE,
                "School Name": Data?.schoolName || Data?.SchoolName,
                // "School Management": Finialrecords?.Names?.schoolManagementName,
                // "Institute": Finialrecords?.Names?.instituteName,
                // "State": Finialrecords?.Names?.stateName,
                "District": Data?.districtId || Data?.District,
                // "Board of Examination": Finialrecords?.Names?.boardName,
                "School Loacation Rural / Urban": Data?.schooltypeId || Data?.SLocation,
                "City": Data?.townCity || Data?.City,
                "Contact name": Data?.contactName || Data?.CName,
                "Contact number": Data?.contactPhone || Data?.PNumber,
                "Email ID": Data?.eMail || Data?.EMail,
                "Address": Data?.address || Data?.Address,
                "Pincode": Data?.pinCode || Data?.Pincode,
                "Medium of Instruction": Data?.mediumId || Data?.MOI,
            }

        })
        exportToExcel(XL, "Invalid School Deatils", false, "Invalid School Deatils", "Invalid School Deatils", true);
    }

    return (
        <>
            <IoMdCloseCircleOutline className="DetailsClose CPointer" style={{ top: "0px" }} onClick={() => props.Close(false)} />
            <div className="dflex " style={{ justifyContent: "flex-start" }}>
                {Finialrecords?.length <= 0 && <div className="dflex alignitems gap-1 CPointer LinkStyles"
                    onClick={() => DownloadSamplefile()}> <MdFileDownload />Download Template</div>}
            </div>
            <div className="MainHeading mt-2 mb-2">Bulk upload of School Registrations - {props?.SINID?.display},
                {props?.SINID?.value === 2 ? [props?.SStatte?.display, props?.SRegion?.display].filter(Boolean).join(",")
                    : [props?.SRegion?.display, props?.SStatte?.display].filter(Boolean).join(",")}
            </div>
            {Finialrecords?.length <= 0 ? <>

                <div className="gap-3 w-100" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)" }}>
                    <div> <SManagement className="NCLDropdown w-100" LovId={47} name="SchoolManagement" Displayname="Select"
                        SOption={SchoolMDetails.SchoolManagement} onChange={(e) => StoreDetails(e, "SchoolManagement")}
                        labelname={<div className="DropdownHeader"> School Management <span>*</span> </div>} /> </div>

                    <div> <SManagement className="NCLDropdown w-100" LovId={57} name="Boardofexam" Displayname="Select"
                        onChange={(e) => StoreDetails(e, "Boardofexam")} SOption={SchoolMDetails?.Boardofexam}
                        // disable={SFName} {`${SFName ? "DisabledNCLDropdown" : "NCLDropdown"} w-100`}
                        labelname={<div className="DropdownHeader "> Board Of Examination/Affiliation <span>*</span> </div>} /></div>
                </div>

                <div className="mt-2 dflex JCCenter alignitems flexd-column p-3">
                    <div className="dflex alignitems JCCenter gap-1">
                        <RiFileExcel2Fill fontSize={60} color="#107c41" />
                        <div
                            {...getRootProps()} className="CPointer dflex alignitems JCCenter p-2 w-100"
                            style={{
                                border: "2px dashed #1436a5", textAlign: "center", borderRadius: "5px",
                                backgroundColor: "#e0e7ff",
                                // backgroundColor: (SchoolMDetails.SchoolManagement && SchoolMDetails?.Boardofexam) ? "#e0e7ff" : "#f8f9fa",
                            }}
                        >
                            <input {...getInputProps()} />
                            {SFName ? <p className="m-0">{SFName}</p> : <p className="m-0">Select File</p>}
                        </div>
                    </div>
                    <p>Select or Drag and drop file</p>
                </div>
                <div className="BlinkingText" style={{ color: "#4e4eff" }}><b>Note :</b> The Schools will be uploaded under '{props?.SINID?.display}' Institute
                    {props?.SINID?.value === 2
                        ? `,'${props?.SStatte?.display}' State for the Region '${props?.SRegion?.display}'`
                        : `${props?.SRegion?.display ? `,'${props?.SRegion?.display}' Region` : ""} for the State '${props?.SStatte?.display}'`
                    }

                </div>
                {SFName && ValidRecords?.schools?.length > 0 && <div className="dflex alignitems JCCenter">
                    <button className="Buttons mt-3" onClick={() => PostRecords()}>Upload the schools</button>
                </div>}
                {SFName && InValidRecords?.length > 0 && ValidRecords?.schools?.length <= 0 && <div className="dflex alignitems JCCenter">
                    <button className="Buttons mt-3 p-3 dflex alignitems JCCenter gap-1" onClick={() => DownloadFIle()}
                        style={{ fontWeight: "600", background: "linear-gradient(135deg,#16a085,#1abc9c)", }} >
                        <RiDownload2Fill /> Download Invalid data </button></div>}
            </> :
                <>
                    <div className="dflex JSBetween gap-2 mt-3" style={{ color: "white" }}>

                        <div className="p-3 Filedetails" style={{ background: "linear-gradient(135deg,#3498db,#2980b9)" }} >
                            <b style={{ fontSize: "24px" }}> {Finialrecords?.TotalRecords} </b>
                            <div >Total Records</div>
                        </div>

                        <div className="p-3 Filedetails" style={{ background: "linear-gradient(135deg,#2ecc71,#27ae60)" }} >
                            <b style={{ fontSize: "24px" }}> {Finialrecords?.ValidRecords} </b>
                            <div >Records Uploaded</div>
                        </div>

                        <div className="p-3 Filedetails" style={{ background: "linear-gradient(135deg,#e74c3c,#c0392b)" }} >
                            <b style={{ fontSize: "24px" }}> {Finialrecords?.INValidCount}</b>
                            <div >Invalid Records</div>
                        </div>

                    </div>
                    <div className="MainHeading mt-2 Greencolor">Bulk upload completed successfully.</div>
                    {Finialrecords?.INValidCount > 0 &&
                        <button className="Buttons mt-3 w-100 p-3 dflex alignitems JCCenter gap-1" onClick={() => DownloadFIle()}
                            style={{ fontWeight: "600", background: "linear-gradient(135deg,#16a085,#1abc9c)", }} >
                            <RiDownload2Fill /> Download Invalid data </button>}
                </>
            }
        </>
    )
}
export default SchoolBulk;